// test678
(678 && 0);
